// extracted by mini-css-extract-plugin
module.exports = {"content":"notification-module__content--EsETs"};